import {
  FootballLiveScore,
  IFootballLiveScore,
} from "@sky-it-livedata/livedata-sports-design-system";
import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LiveScoreQuery, LiveScoreSubscription } from "./types";
import transformQuery from "./transformers/query";
import transformSubscription from "./transformers/subscription";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LiveScoreQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = `subscription LiveScoreSubcription {\n  onUpdateLiveScoreById(id: \"unique\") {\n    id\n    currentDay {\n      matchRoundList {\n        matchDayList {\n          matchList {\n            status\n            competitionPhaseWinnerTeamId\n            home {\n              goal\n              overtimeGoal\n              shootoutGoal\n              totalGoalLegs\n            }\n            away {\n              goal\n              overtimeGoal\n              shootoutGoal\n              totalGoalLegs\n            }\n          }\n        }\n      }\n    }\n  }\n}`;

export const getServerProps = ({
  props,
}: WidgetContext<LiveScoreQuery>): IFootballLiveScore => {
  return transformQuery(props);
};

const LiveScoreWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<IFootballLiveScore>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    IFootballLiveScore,
    LiveScoreSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as IFootballLiveScore;

  return (
    <div onClick={intCmpEventHandler}>
      <FootballLiveScore {...updatedProps} />
    </div>
  );
};

export default LiveScoreWidget;
